// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"kcCfC":[function(require,module,exports) {
require("f157ac38e76f6e30").register(require("cd3c38f83a76ade9").getBundleURL("aU9Vj"), JSON.parse('["aU9Vj","index.28efec85.js","hxc5z","beep.f20d5237.mp3","2jZwM","success.08c92973.mp3"]'));

},{"f157ac38e76f6e30":"fyJL2","cd3c38f83a76ade9":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"4ZrZU":[function(require,module,exports) {
// ui.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Function to show only the required view
parcelHelpers.export(exports, "toggleView", ()=>toggleView);
// Apply workout format and start workout if valid
parcelHelpers.export(exports, "initializeWorkout", ()=>initializeWorkout);
parcelHelpers.export(exports, "setExerciseText", ()=>setExerciseText);
parcelHelpers.export(exports, "populateExerciseList", ()=>populateExerciseList);
// Function to provide audio feedback by speaking text
parcelHelpers.export(exports, "speakText", ()=>speakText);
parcelHelpers.export(exports, "updateTimerDisplayCoral", ()=>updateTimerDisplayCoral);
parcelHelpers.export(exports, "updateTimerDisplayYellow", ()=>updateTimerDisplayYellow);
// Helper functions for consistency
parcelHelpers.export(exports, "playBeepSound", ()=>playBeepSound);
parcelHelpers.export(exports, "playSuccessSound", ()=>playSuccessSound);
parcelHelpers.export(exports, "updateUpNextText", ()=>updateUpNextText);
parcelHelpers.export(exports, "activateShareButton", ()=>activateShareButton);
var _cookiesJs = require("./cookies.js");
var _workoutGeneratorJs = require("./workoutGenerator.js");
var _workoutTimesJs = require("./workoutTimes.js");
const todaysWorkout = (0, _workoutGeneratorJs.getTodaysWorkout)();
document.addEventListener("DOMContentLoaded", ()=>{
    const overlay = document.getElementById("intro-overlay");
    const closeButton = document.getElementById("close-intro");
    const checkbox = document.getElementById("hide-on-future-loads");
    // Show overlay if the cookie does not exist or is false
    if (!(0, _cookiesJs.getHideIntroOverlay)()) overlay.style.display = "flex";
    // Handle close button click and set cookie if checkbox is checked
    closeButton.addEventListener("click", ()=>{
        overlay.style.display = "none";
        if (checkbox.checked) (0, _cookiesJs.setHideIntroOverlay)();
    });
    // Show overlay when the logo is clicked
    document.querySelector(".logo").addEventListener("click", ()=>{
        overlay.style.display = "flex";
    });
    // Show overlay when "HIIT Genius" link is clicked
    document.getElementById("hiit-genius-link").addEventListener("click", (e)=>{
        e.preventDefault();
        overlay.style.display = "flex";
    });
    document.getElementById("privacy-policy-link").addEventListener("click", (e)=>{
        e.preventDefault();
        document.getElementById("privacy-policy-overlay").style.display = "flex";
    });
    document.getElementById("close-privacy-policy").addEventListener("click", ()=>{
        document.getElementById("privacy-policy-overlay").style.display = "none";
    });
    document.getElementById("terms-conditions-link").addEventListener("click", (e)=>{
        e.preventDefault();
        document.getElementById("terms-conditions-overlay").style.display = "flex";
    });
    document.getElementById("close-terms-conditions").addEventListener("click", ()=>{
        document.getElementById("terms-conditions-overlay").style.display = "none";
    });
    // Initial orientation check
    handleOrientationChange();
});
// Function to check if it's a mobile device with a small screen (like iPhone)
function isSmallMobileScreen() {
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const screenIsSmall = window.innerWidth <= 800 && window.innerHeight <= 800; // Target small screens (like iPhones)
    return isMobile && screenIsSmall;
}
// Handle changes in screen orientation
function handleOrientationChange() {
    const landscapeWarning = document.getElementById("landscape-warning");
    if (isSmallMobileScreen()) {
        const isLandscape = window.innerWidth > window.innerHeight;
        landscapeWarning.style.display = isLandscape ? "flex" : "none";
    } else landscapeWarning.style.display = "none";
}
// Listen for orientation changes
window.addEventListener("resize", handleOrientationChange);
function toggleView(showId) {
    const views = [
        "workout-container",
        "timer-container",
        "success-container"
    ];
    views.forEach((viewId)=>{
        document.getElementById(viewId).style.display = viewId === showId ? "flex" : "none";
    });
}
const workoutFormats = {
    "30:30": {
        exerciseTime: 30,
        breakTime: 30
    },
    "40:20": {
        exerciseTime: 40,
        breakTime: 20
    },
    "50:20": {
        exerciseTime: 50,
        breakTime: 20
    },
    "30:15": {
        exerciseTime: 30,
        breakTime: 15
    },
    "60:30": {
        exerciseTime: 60,
        breakTime: 30
    }
};
function initializeWorkout(format) {
    const selectedFormat = workoutFormats[format];
    if (selectedFormat) {
        if (format === "30:15") (0, _workoutGeneratorJs.doubleTodaysWorkout)();
        // Set the workout times based on the selected format
        (0, _workoutTimesJs.setWorkoutTimes)(selectedFormat.exerciseTime, selectedFormat.breakTime);
    } else console.error("Invalid workout format selected");
}
function setExerciseText(content) {
    document.getElementById("exercise").textContent = content;
}
function populateExerciseList() {
    const exerciseListDiv = document.getElementById("exerciseList");
    const ul = document.createElement("ul");
    todaysWorkout.forEach((exercise)=>{
        const li = document.createElement("li");
        // Create the exercise text span
        const exerciseText = document.createElement("span");
        exerciseText.textContent = exercise.name;
        exerciseText.style.flexGrow = "1"; // Allow text to take up available space
        // Create the link emoji
        const link = document.createElement("a");
        link.href = `https://www.google.com/search?q=${exercise.linkValue}+how+to`;
        link.target = "_blank";
        link.textContent = "\uD83D\uDD17";
        link.className = "link-emoji"; // Use the CSS class for styling
        // Append the text and link to the list item
        li.appendChild(exerciseText);
        li.appendChild(link);
        ul.appendChild(li);
    });
    exerciseListDiv.appendChild(ul);
}
function speakText(text) {
    const speech = new SpeechSynthesisUtterance(text);
    speech.lang = "en-US";
    window.speechSynthesis.speak(speech);
}
function updateTimerDisplayCoral(remainingSeconds, percentage) {
    updateTimerDisplay(remainingSeconds, percentage, "#FF6F61");
}
function updateTimerDisplayYellow(remainingSeconds, percentage) {
    updateTimerDisplay(remainingSeconds, percentage, "#FFD700");
}
function updateTimerDisplay(remainingSeconds, percentage, color) {
    const overlay = document.getElementById("circle-overlay");
    overlay.style.background = `conic-gradient(${color} ${percentage}%, rgba(${hexToRgb(color)}, 0) ${percentage}%)`;
    document.getElementById("countdown").textContent = remainingSeconds;
}
function hexToRgb(hex) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return `${r}, ${g}, ${b}`;
}
// Import audio files
const beepAudio = new URL(require("89f3f230689ab78"));
const successAudio = new URL(require("7692b91ee2d8a5a3"));
let audioContext;
document.addEventListener("click", ()=>{
    if (!audioContext) {
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        console.log("AudioContext created.");
    }
});
function playSound(soundType) {
    const soundFile = soundType === "success" ? successAudio : beepAudio;
    // Fetch and decode audio
    fetch(soundFile).then((response)=>{
        if (!response.ok) throw new Error("Network response was not ok");
        return response.arrayBuffer();
    }).then((data)=>audioContext.decodeAudioData(data)).then((buffer)=>{
        const source = audioContext.createBufferSource();
        source.buffer = buffer;
        source.connect(audioContext.destination);
        source.start(0);
        console.log(`${soundType.charAt(0).toUpperCase() + soundType.slice(1)} sound played successfully.`);
    }).catch((error)=>console.error("Failed to load or play sound:", error));
}
function playBeepSound() {
    playSound("beep");
}
function playSuccessSound() {
    playSound("success");
}
function updateUpNextText(nextText) {
    const upNextElement = document.getElementById("up-next-text");
    if (nextText) {
        upNextElement.textContent = nextText;
        upNextElement.style.display = "block"; // Show the element
    } else upNextElement.style.display = "none"; // Hide the element
}
function activateShareButton(socialMediaPost) {
    const shareButton = document.getElementById("share-button");
    shareButton.addEventListener("click", async ()=>{
        try {
            // Always copy the socialMediaPost to clipboard first
            await navigator.clipboard.writeText(socialMediaPost);
            console.log("Content copied to clipboard.");
            if (navigator.share && isMobileDevice()) {
                const shareData = {
                    text: socialMediaPost // Default message for sharing
                };
                try {
                    // Show a message to the user instructing them about Facebook limitations
                    alert("Content copied to clipboard!");
                    // Proceed with the Web Share API
                    await navigator.share(shareData);
                } catch (error) {
                    console.log("Something went wrong sharing the content", error);
                }
            } else // For desktop or unsupported browsers, just notify that the content was copied
            alert("Content copied to clipboard! You can now paste it anywhere.");
        } catch (clipboardError) {
            console.log("Failed to copy to clipboard", clipboardError);
            alert("Failed to copy content. Please copy it manually.");
        }
    });
    function isMobileDevice() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }
}

},{"./cookies.js":"4DKFW","./workoutGenerator.js":"3p0gh","./workoutTimes.js":"4965e","89f3f230689ab78":"cG5Y2","7692b91ee2d8a5a3":"gtK9U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cG5Y2":[function(require,module,exports) {
module.exports = require("c97332186454559c").getBundleURL("aU9Vj") + "beep.f20d5237.mp3";

},{"c97332186454559c":"c7Tr5"}],"gtK9U":[function(require,module,exports) {
module.exports = require("a866e92b8460f289").getBundleURL("aU9Vj") + "success.08c92973.mp3";

},{"a866e92b8460f289":"c7Tr5"}]},["kcCfC","4ZrZU"], "4ZrZU", "parcelRequire3809")

//# sourceMappingURL=index.28efec85.js.map
